import { FieldControl } from '@signature-it/ngx-generic/enums';
import {SelectField} from "./select";

export class FlatImageGalleryField extends SelectField {
    controlType = FieldControl.FLAT_IMAGE_GALLERY;
    constructor(options: {} = {}) {
        super(options);
		this.dynamicOptions = true;
    }
}
